/** Home Paths */
export const HOME_PATH = "/";

/** Login Paths */
export const LOGIN_PATH = "/login";
export const LOGIN_VERIFICATION_PATH = "verification";
export const FORGOT_PASSWORD_PATH = "/forgot-password";
export const FORGOT_PASSWORD_EMAIL_PATH = "email";
export const FORGOT_PASSWORD_UPDATE_PATH = "update";
export const FORGOT_PASSWORD_SUCCESS_PATH = "success";

/** Order Qoutes Paths */
export const ORDER_QUOTE_PATH = "/order-quotes";
export const CREATE_ORDER_QUOTE_PATH = "create";
export const EDIT_ORDER_QUOTE_PATH = "edit";

/** Manage Users Paths */
export const MANAGE_USERS_PATH = "/users";
export const CREATE_MANAGE_USERS_PATH = "create";

/** Web Store Request Paths */
export const WEB_STORE_REQUEST_PATH = "/webstorerequest";
export const WEB_STORE_REQUEST_ONLINE_PATH = "/webstorerequestonline";

/** Error Paths */
export const ERROR_PATH = "/error";

/** Profile Paths */
export const PROFILE_PATH = "/profile";
export const PROFILE_DETAILS_PATH = `details`;
export const PROFILE_PASSWORD_PATH = `password`;
